import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/firebase";
const PRIVATE_PREFIXES = [
  "/admin",
  "/dashboard",
  "/login",
  "/signup",
  "/verify-email",
  "/forgot-password",
  "/reset-password",
];
export default function AnalyticsRouteTracker() {
  const { pathname, search } = useLocation(),
    last = useRef("");
  useEffect(() => {
    if (PRIVATE_PREFIXES.some((prefix) => pathname.startsWith(prefix))) return;
    const route = `${pathname}${search}`;
    if (last.current === route) return;
    last.current = route;
    trackPageView(route);
  }, [pathname, search]);
  return null;
}
